/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CarveOutTrackingListEntryLeadAllOfAssignmentsInner
 */
export interface CarveOutTrackingListEntryLeadAllOfAssignmentsInner {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    user_id: string;
    /**
     * 
     */
    role: CarveOutTrackingListEntryLeadAllOfAssignmentsInnerRoleEnum;
}


/**
 * @export
 */
export const CarveOutTrackingListEntryLeadAllOfAssignmentsInnerRoleEnum = {
    Owner: 'OWNER',
    Liaison: 'LIAISON',
} as const;
export type CarveOutTrackingListEntryLeadAllOfAssignmentsInnerRoleEnum = typeof CarveOutTrackingListEntryLeadAllOfAssignmentsInnerRoleEnum[keyof typeof CarveOutTrackingListEntryLeadAllOfAssignmentsInnerRoleEnum];


/**
 * Check if a given object implements the CarveOutTrackingListEntryLeadAllOfAssignmentsInner interface.
 */
export function instanceOfCarveOutTrackingListEntryLeadAllOfAssignmentsInner(value: object): value is CarveOutTrackingListEntryLeadAllOfAssignmentsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('user_id' in value) || value['user_id'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function CarveOutTrackingListEntryLeadAllOfAssignmentsInnerFromJSON(json: any): CarveOutTrackingListEntryLeadAllOfAssignmentsInner {
    return CarveOutTrackingListEntryLeadAllOfAssignmentsInnerFromJSONTyped(json, false);
}

export function CarveOutTrackingListEntryLeadAllOfAssignmentsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarveOutTrackingListEntryLeadAllOfAssignmentsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'user_id': json['user_id'],
        'role': json['role'],
    };
}

export function CarveOutTrackingListEntryLeadAllOfAssignmentsInnerToJSON(json: any): CarveOutTrackingListEntryLeadAllOfAssignmentsInner {
    return CarveOutTrackingListEntryLeadAllOfAssignmentsInnerToJSONTyped(json, false);
}

export function CarveOutTrackingListEntryLeadAllOfAssignmentsInnerToJSONTyped(value?: CarveOutTrackingListEntryLeadAllOfAssignmentsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'user_id': value['user_id'],
        'role': value['role'],
    };
}

